module.exports = __webpack_public_path__ + "static/media/eugene@2x.f6221f18.webp";